import { render, staticRenderFns } from "./PlayableCreateFromTemplate.vue?vue&type=template&id=3b6b828c&lang=pug"
import script from "./PlayableCreateFromTemplate.vue?vue&type=script&lang=js"
export * from "./PlayableCreateFromTemplate.vue?vue&type=script&lang=js"
import style0 from "./PlayableCreateFromTemplate.vue?vue&type=style&index=0&id=3b6b828c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports